import React from 'react';
import {
    getNetworkQualityTier,
    networkTierToSignalClass,
    NETWORK_QUALITY_COLORS,
    useEffectiveOnlineStatus,
    useNetworkConnectionMetrics,
} from '../../../utils/internetReachability';

const InternetStatus = () => {
    const isOnline = useEffectiveOnlineStatus();
    const { downlink, effectiveType } = useNetworkConnectionMetrics();

    const tier = getNetworkQualityTier(isOnline, downlink, effectiveType);
    const strengthClass = networkTierToSignalClass(tier);
    const borderColor = NETWORK_QUALITY_COLORS[tier];
    const barColor = NETWORK_QUALITY_COLORS[tier];

    const strengthRedClass = strengthClass === 'signal-icon-offline' ? 'signal-strength-offline' : '';

    return (
        <div
            style={
                {
                    borderColor,
                    ['--signal-bar-active' as string]: barColor,
                } as React.CSSProperties
            }
            className={`routerContainer flex relative border-circle justify-content-center align-items-center ${strengthRedClass}`}
        >
            <div className={`signal-icon signal-icon--dynamic ${strengthClass}`}>
                <div className="signal-bar"></div>
                <div className="signal-bar"></div>
                <div className="signal-bar"></div>
                {strengthClass === 'signal-icon-offline' && <i className="offline-icon-router pi pi-times"></i>}
            </div>
        </div>
    );
};

export default InternetStatus;
